import { faker } from '@faker-js/faker'
import { Factory } from 'miragejs'

export default Factory.extend({
  firstName(i) {
    faker.seed(i)
    return faker.person.firstName()
  },
  lastName(i) {
    faker.seed(i)
    return faker.person.lastName()
  },
  email() {
    return faker.internet.email()
  },

  login: 'disco_us',
  countryCode: 'US',
  get products() {
    return ['reading', 'maths', 'mathletics']
  },
})
